import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=b208d696&scoped=true&"
import script from "./ClientCard.vue?vue&type=script&lang=ts&"
export * from "./ClientCard.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCard.vue?vue&type=style&index=0&id=b208d696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b208d696",
  null
  
)

export default component.exports